/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contact } from '../../models/contact';

export interface ContactGetContact$Params {

/**
 * GUID of the user contact
 */
  userId: string;
}

export function contactGetContact(http: HttpClient, rootUrl: string, params: ContactGetContact$Params, context?: HttpContext): Observable<StrictHttpResponse<Contact>> {
  const rb = new RequestBuilder(rootUrl, contactGetContact.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Contact>;
    })
  );
}

contactGetContact.PATH = '/contact/{userId}';
